import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";
import Vue from 'vue';
import Account from '@/helper/AccountHelper.js'

/**
 * @method apiGetLeaderBoardContent
 */

 export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    /**
     * Return announce content
     */
     apiGetLeaderBoardBlob: function() {
        var url = ConfigManager.getBlobUrl() + `/webconfig/${ConfigManager.getBlobConfigDev()}/leaderboard/leaderboard.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
     apiGetLeaderBoardConditionBlob: function() {
        var url = ConfigManager.getBlobUrl() + `/webconfig/${ConfigManager.getBlobConfigDev()}/leaderboard/leaderboard_condition.txt`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
    apiGetLeaderBoarder: function(type) {
        var token = Account.getToken();
        var url = this.config().bzbsModuleUrl + `/leaderboard/${type}`;
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map(res => {
            res.data.type = type
            return res.data
        }));
    }
};